import LetterCircle from './LetterCircle';

export default function GameBoard({
  letters,
  selectedLetters,
  connectorPath,
  connectedPath,
  startSelection,
  dragSelection,
}) {
  return (
    <svg
      viewBox="0 0 100 100"
      className="w-full h-full user-selection"
    >
      <defs>
        <pattern
          id="letterBg"
          patternUnits="userSpaceOnUse"
          x="-11"
          y="-11"
          width="23"
          height="23"
        >
          <image
            href={`${process.env.PUBLIC_URL}/assets/images/puzzle/alaphabutton.png`}
            x="-1.5"
            y="-1.5"
            width="25"
            height="25"
            preserveAspectRatio="none"
          />
        </pattern>
      </defs>
      <circle
        cx="51"
        cy="49"
        r="44"
        fill="#fff"
      />

      <path
        d={connectedPath}
        fill="none"
        stroke="#f97316"
        strokeWidth="2"
      />

      <path
        d={connectorPath}
        fill="none"
        stroke="#fb923c"
        strokeWidth="3"
      />

      {letters.map((letter) => (
        <LetterCircle
          key={letter.id}
          letter={letter}
          selected={selectedLetters.includes(
            letter.id
          )}
          onStart={startSelection}
          onEnter={dragSelection}
        />
      ))}
    </svg>
  );
}